//@ts-nocheck
import { BN } from '@project-serum/anchor';
import { TOKEN_PROGRAM_ID } from '@solana/spl-token';
import {
    PublicKey,
    TransactionInstruction,
    SystemProgram,
    SYSVAR_RENT_PUBKEY,
    Transaction,
    Keypair,
} from '@solana/web3.js';
import { DRAFFLE_PROGRAM_ID } from '../../config/programIds';
import { DraffleProgram } from '../../providers/ProgramApisProvider';
import {
    ASSOCIATED_TOKEN_PROGRAM_ID,
    Token,
} from '@solana/spl-token';
export const createRaffle = async (
    draffleClient: DraffleProgram,
    creator: PublicKey,
    proceedsMint: PublicKey,
    endTimestamp: number,
    ticketPrice: number,
    maxEntrants: number,
    prizeMint: PublicKey,
    prizeIndex: number,
    amount: number,
    nftMint: string,
    nftTokenAccount: PublicKey,
    nftMetadataAccount: PublicKey,
   
) => {
    // Create keypair for entrants account
    let entrantsRaw = Keypair.generate();
    let entrants = entrantsRaw.publicKey;

    // Find PDA for Raffle
    const RAFFLE_PREFIX = 'raffle';
    const PROCEEDS_PREFIX = 'proceeds';
    async function getRaffleId(): Promise<PublicKey> {
        let [address] = await PublicKey.findProgramAddress(
            [Buffer.from(RAFFLE_PREFIX), entrants.toBuffer()],
            new PublicKey(DRAFFLE_PROGRAM_ID)
        );
        return address;
    }

    let raffleId = await getRaffleId();

    // Find PDA for Proceeds
    async function getProceedsId(): Promise<PublicKey> {
        let [address] = await PublicKey.findProgramAddress(
            [raffleId.toBuffer(), Buffer.from(PROCEEDS_PREFIX)],
            new PublicKey(DRAFFLE_PROGRAM_ID)
        );
        return address;
    }

    let proceedsId = await getProceedsId();

    // Begin transaction instructions
    let instructions: TransactionInstruction[] = [];

    // Find rent for entrants max length
    let dataLength = 8 + 4 + 4 + 32 * maxEntrants;
    const rentExemptionAmount =
        await draffleClient.provider.connection.getMinimumBalanceForRentExemption(
            dataLength
        );

    // Fund entrants Account
    instructions.push(
        SystemProgram.createAccount({
            fromPubkey: creator,
            newAccountPubkey: entrants,
            lamports: rentExemptionAmount,
            space: dataLength,
            programId: new PublicKey(DRAFFLE_PROGRAM_ID),
        })
    );


    // Find Prize PDA for backend init
    const PRIZE_PREFIX = 'prize';
    async function getPrizeId(): Promise<PublicKey> {
        let [address] = await PublicKey.findProgramAddress(
            [
                new PublicKey(raffleId).toBytes(),
                Buffer.from(PRIZE_PREFIX)
            ],
            new PublicKey(DRAFFLE_PROGRAM_ID)
        );
        return address;
    }

    let prizeId = await getPrizeId();

    // ATA of prize mint
    let creatorPrizeAddress = await Token.getAssociatedTokenAddress(
        ASSOCIATED_TOKEN_PROGRAM_ID,
        TOKEN_PROGRAM_ID,
        prizeMint,
        creator
    );
    // console.log(8 + 32 + 4 + 4 + 4 + 32 + 8 + 8 + 32 + 4 + 1 + 4 + 1, 'total space')

    // console.log(new Date(endTimestamp), 'end date')
    // console.log(new BN(endTimestamp).toString(), 'final endtimestamp')
    // console.log(new BN(String(endTimestamp)).toString(), 'final endtimestamp argument')
    // Create raffle
    if (endTimestamp)
        instructions.push(
            draffleClient.instruction.createRaffle(
            //@ts-ignore
            new BN(endTimestamp),
            new BN(ticketPrice),
            new BN(maxEntrants),
            true,
                new BN(prizeIndex),
                new BN(amount),            
            {
                accounts: {
                    raffle: raffleId,
                    entrants: entrants,
                    creator: creator,
                    proceeds: proceedsId,
                    proceedsMint: proceedsMint,
                    nftMint: new PublicKey(nftMint),
                    nftTokenAccount: nftTokenAccount,
                    nftMetadataAccount,
                    tokenMetadataProgram: new PublicKey(process.env.REACT_APP_METAPLEX_TOKEN_PROGRAM || "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s"),
                    from: creatorPrizeAddress,
                    prize: prizeId,
                    prizeMint: prizeMint,
                    systemProgram: SystemProgram.programId,
                    tokenProgram: TOKEN_PROGRAM_ID,
                    rent: SYSVAR_RENT_PUBKEY,
                },
            }
        )
    );


    const status = await draffleClient.provider.sendAndConfirm(
        new Transaction().add(...instructions),
        [entrantsRaw]
    );
    console.log(status, 'raffle creation status')
    // Sign with entrants keypair
    return (raffleId.toBase58())
};
